module.exports = __webpack_public_path__ + "img/pasta-e-fagioli-thumb.fba20b8b.png";